<a
  (click)="sectionClick.emit()"
  data-tms-event="link-click"
  data-cy="myBillOdbSectionVariantTwoLink"
  [attr.data-tms-link-zone]="linkZone"
  [attr.data-tms-link-name]="label"
  class="rs-entrypoint"
  *ngIf="isClickable; else showPlainText"
>
  <span class="rs-entrypoint-title">{{ label }}</span>
  <span class="rs-entrypoints-extra">
    <strong>
      <px-currency-amount [amount]="amount"></px-currency-amount
    ></strong>
  </span>
  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
</a>
<ng-template #showPlainText>
  <div class="rs-flex-row">
    <div class="rs-flex-column">
      <p class="rs-txt-primary rs-font-pxB">
        <span *ngIf="!isClickable">{{ label }}</span>
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <p class="rs-font-pxB">
        <px-currency-amount [amount]="amount"></px-currency-amount>
      </p>
    </div>
  </div>
</ng-template>
